
  import ScreenSize from '@/mixins/ScreenSize';
  import {prepareImageUrl} from '@/helper/ImageHelper';
  export default {
    components: {
      RichText: () => import('@/components/elements/RichText'),
    },
    mixins: [ScreenSize],
    props: {
      testimonial: {
        type: Object,
        required: false,
        default: () => {},
      },
      cardStyle: {
        type: String,
        required: false,
        default: 'white',
      },
      index: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        imageUrl: process.env.NUXT_ENV_FALLBACK_CARD_IMAGE_STATIC,
      };
    },
    created() {
      if (this.testimonial.image) {
        this.imageUrl = prepareImageUrl(this.testimonial.image.url);
      }
    },
  };
